import React from 'react'
import { Box, Container } from '@mui/material'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import CustomButton from '../../../Components/CustomButton/CustomButton'

import { makeGetRequest, makePostRequest } from '../../../utils/api'
import urls from '../../../utils/urls'
import CreateOperationForm from './CreateOperationForm'
import ListOperations from './ListOperations'
import EditOperationForm from './EditOperationForm'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function Operations() {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [operations, setOperations] = useState({})
  const [selectedRowsParams, setSelectedRowsParams] = useState({})
  const [selectedRows, setSelectedRows] = useState([])

  const [loading, setLoading] = useState(false)
  const [types, setTypes] = useState([])
  const [general, setGeneral] = useState(true)
  const [selected, setSelected] = useState(false)

  useEffect(() => {
    fetchOperations()
    fetchVehiclesTypes()
  }, [])

  const fetchOperations = async (pagination = '') => {
    setLoading(true)
    let url = `${urls.crudBudgetOpertations}?general=${general}`

    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({ ...response.data })
      setLoading(false)
    }
    setLoading(false)
  }

  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert(t('finance.monBudget.selectOneOperation'))
    } else {
      const filteredOperations = operations.results.filter((v) => selectedRows.indexOf(v.id) === -1)
      setOperations({
        ...operations,
        results: filteredOperations,
        count: operations.count - selectedRows.length,
      })
      const response = await makePostRequest(
        urls.deleteBulkBudgetOperations,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        console.log('Deleted Successfully')
      }
    }
  }

  const fetchVehiclesTypes = async () => {
    const url = urls.fetchVehiclesTypes + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.vehicletype}`, id: v.id })
      })
      setTypes([...filterTypes])
    }
  }

  return (
    <>
      <Container maxWidth="xl" sx={{ px: 0 }}>
        <Box justifyContent="flex-end" padding={2} display="flex">
          <Box>
            <CreateOperationForm setOperations={setOperations} vehiculesTypes={types} />
            <CustomButton
              onClick={() => {
                if (selectedRows.length === 1) {
                  setSelectedRowsParams({
                    ...operations.results.filter((v) => v.id === selectedRows[0]),
                  })
                  setSelected(true)
                } else {
                  setSelected(false)
                  alert(t('finance.monBudget.selectOneToEdit'))
                }
              }}
            >
              {t('finance.common.edit')}
            </CustomButton>
            {selected ? (
              <EditOperationForm
                setOperations={setOperations}
                setSelected={setSelected}
                params={selectedRowsParams}
                operations={operations}
              />
            ) : (
              ''
            )}

            <CustomButton onClick={deleteBulkOperations}>{t('finance.common.delete')}</CustomButton>
          </Box>
        </Box>

        <ListOperations
          fetchOperations={fetchOperations}
          setSelectedRows={setSelectedRows}
          operations={operations}
        />
      </Container>
    </>
  )
}
